export default class CompLoadPlugin {
  event: any;

  constructor({ event }: any) {
    this.event = event;
  }

  cacheEventEmitCompLoadComs: Record<string, any> = {};

  beforeBind() {
    if (!this.cacheEventEmitCompLoadComs) {
      this.cacheEventEmitCompLoadComs = {};
    }

    return false;
  }

  // 阻止event 事件触发，由插件内部自行定义出发规则
  beforeEmit(args: any[]) {
    if (!this.cacheEventEmitCompLoadComs) {
      this.cacheEventEmitCompLoadComs = {};
    }

    const [comId, ...restArgs] = args;
    const name = `compLoad_${comId}`;
    const fn = () => this.event.emitWithReturns(name, ...restArgs);

    if (!this.cacheEventEmitCompLoadComs[comId!]) {
      this.cacheEventEmitCompLoadComs[comId!] = fn;
    }

    // 额外触发compLoad 事件
    this.event._event.emit('compLoad', ...args);

    return true;
  }

  afterBind(args: any[]) {
    const [comId] = args;

    const emitFns = this.cacheEventEmitCompLoadComs[comId as string];

    if (emitFns) {
      emitFns();
    }
  }
}
